import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ValidarSesion } from "../shared/Validaciones";
import Menu from "./components/Menu";
import Aviso, { mostrarAviso } from "./components/Aviso";
import { dB64 } from "../shared/Encriptacion";
import { HEADERS_API } from "./NuevaGuia";
import axios from "axios";
import { ListaDepartamentos, ListaDistritos, ListaProvincias } from "../shared/Ubigeo";
import { ValidarNum } from "../shared/Regex";


export default function DetalleCliente(){
    // ======================================================================================================
    //#region HOOKS STATE
    // ======================================================================================================
    // ESTADOS DE ACTUALIZACIÓN
    const[tipoDoc, setTipoDoc] = useState("");
    const[nroDoc, setNroDoc] = useState("");
    const[nombre, setNombre] = useState("");
    const[esProveedor, setEsProveedor] = useState(false);
    const[direccion, setDireccion] = useState("");
    const[ubigeo, setUbigeo] = useState("");
    const[dpto, setDpto] = useState("");
    const[prov, setProv] = useState("");
    const[dist, setDist] = useState("");

    // ESTADOS DE VALIDACIÓN

    // ESTADOS DE CONTENIDO
    const[selectTipoDoc, setSelectTipoDoc] = useState(<></>);
    //#endregion

    // ESTADOS DE VALIDACIÓN
    const[datosCompletos, setDatosCompletos] = useState(false);
    // ======================================================================================================
    //#region HOOKS EFFECT
    // ======================================================================================================
    
    useEffect(()=>{
        const cargaInicial = async () => {
            ValidarSesion();
            await ObtenerTiposDocumento();
            ObtenerDatosCliente();
        }

        cargaInicial();
    },[]);

    // Actualizar ubigeo y reestablecer inferiores al cambiar departamento, provincia o distrito de partida
    useEffect(()=>{
        if(dpto == ""){
            HandlerProv("");

        }else{
            HandlerProv("01");
        }
        HandlerUbigeo(`${dpto}${prov}${dist}`);
    },[dpto]);
    useEffect(()=>{
        if(prov == ""){
            HandlerDist("");
        }else{
            HandlerDist("01");
        }
        HandlerUbigeo(`${dpto}${prov}${dist}`);
    },[prov]);
    useEffect(()=>{
        HandlerUbigeo(`${dpto}${prov}${dist}`);
    },[dist]);

    useEffect(()=>{
        if(direccion == ""){
            HandlerDpto("");
        }
    },[direccion]);

    // VALIDAR QUE LOS DATOS ESTÉN COMPLETOS
    useEffect(()=>{
        try{
            if(tipoDoc == "" || nroDoc == "" || nombre == ""){
                throw new Error();
            }
            if(tipoDoc == "1" && nroDoc.length != 8){
                throw new Error();
            }
            if(tipoDoc == "6" && nroDoc.length != 11){
                throw new Error();
            }
            if(direccion != "" && ubigeo.length != 6){
                throw new Error();
            }
            HandlerDatosCompletos(true);
        }catch(error){
            HandlerDatosCompletos(false);
        }
    },[tipoDoc, nroDoc, nombre, direccion, ubigeo]);

    //#endregion

    // ======================================================================================================
    //#region  HOOK NAVIGATE PARAMS
    // ======================================================================================================
    const navigate = useNavigate();
    const{codClienteActualizar} = useParams();
    //#endregion
    

    // ======================================================================================================
    //#region HANDLERS
    // ======================================================================================================
    const HandlerTipoDoc = (valor) => setTipoDoc(valor);
    const HandlerNroDoc = (valor) => {
        if(ValidarNum(valor) || valor == ""){
            setNroDoc(valor);
        }
    }
    const HandlerNombre = (valor) => setNombre(valor.toUpperCase());
    const HandlerEsProveedor = (valor) => setEsProveedor(valor);
    const HandlerDireccion = (valor) => setDireccion(valor.toUpperCase());
    const HandlerUbigeo = (valor) => setUbigeo(valor);
    const HandlerDpto = async (valor) => setDpto(valor);
    const HandlerProv = async (valor) => setProv(valor);
    const HandlerDist = async (valor) => setDist(valor);
    //ESTADOS DE VALIDACIÓN
    const HandlerDatosCompletos = (valor) => setDatosCompletos(valor);
    
    
    //ESTADOS DE CONTENIDO
    const HandlerSelectDocumentos = (lista) => {
        setSelectTipoDoc(<>{
            lista.map((item, index) => (
                <option key={index} value={item.codigo}>{item.descripcion}</option>
            ))}</>)
    }

    //#endregion

    // ======================================================================================================
    //#region FUNCIONES
    // ======================================================================================================
    // FUNCIONES ASÍNCRONAS
    const ObtenerTiposDocumento = async () => {
        try{
            const response = await axios.get(URL_CONSULTA_TIPOS_DOCUMENTO, {
                headers: HEADERS_API
            }).catch(error =>{
                throw new Error(error.message);
            });

            HandlerSelectDocumentos(response.data.lista);
            HandlerTipoDoc(response.data.lista[0].codigo);
        }catch(error){
            console.log(error.message);
        }
    }
    const ObtenerDatosCliente = async () => {
        try{
            const response = await axios.get(URL_DATOS_CLIENTE,{
                headers: HEADERS_API,
                params: {
                    codigoConsultar: codClienteActualizar
                }
            }).catch(error => {
                throw new Error(error.message);
            });

            const datos = response.data;

            if(datos["nroDoc"] == null){
                throw new Error("El cliente no existe");
            }

            setTimeout(() => {
                HandlerTipoDoc(datos["tipoDoc"]);
            }, 10);
            HandlerNroDoc(datos["nroDoc"]);
            if(datos["esProveedor"] == 1){
                HandlerEsProveedor(true);
            }else{
                HandlerEsProveedor(false);
            }
            HandlerNombre(datos["nombre"]);
            HandlerDireccion(datos["direccion"]);
            HandlerDpto(datos["ubigeo"].substring(0,2));
            setTimeout(() => {
                HandlerProv(datos["ubigeo"].substring(2,4));
                setTimeout(() => {
                    HandlerDist(datos["ubigeo"].substring(4,6));
                }, 10);
            }, 10);
        }catch(error){
            console.log(error);
            navigate('/clientes-proveedores');
        }
    }
    const EditarCliente = async () => {
        const paramEsProv = esProveedor ? 1 : 0;
        try{
            let response = await axios.put(URL_EDITAR_CLIENTE, {
                codigoClienteEditar: codClienteActualizar,
                tipoDoc: tipoDoc,
                nroDoc: nroDoc,
                nombre: nombre,
                esProveedor: paramEsProv,
                direccion: direccion,
                ubigeo: ubigeo
            }, {
                headers: HEADERS_API
            }).catch(error => {
                throw new Error(error.response.data);
            });

            navigate("/clientes-proveedores");
        }catch(error){
            mostrarAviso(error, 2500);
        }
    }
    //#endregion

    // ======================================================================================================
    //#region CONTENIDO
    // ======================================================================================================
    return(<>
    <Menu/>
    <Aviso/>
    <div className="container">
        <div className="row">
            <div className="col-12 py-2 border-bottom border-secondary text-secondary text-center text-md-start">
                <h2>{dB64(localStorage.getItem('r6'))}</h2>
            </div>
            <div className='col-12 p-3 text-secondary'>
                <Link className='' to={'/clientes-proveedores'}>
                    <button className='btn btn-secondary'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-return-left" 
                        viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M14.5 1.5a.5.5 0 0 1 .5.5v4.8a2.5 2.5 0 0 1-2.5 2.5H2.707l3.347 3.346a.5.5 0 0 1-.708.708l-4.2-4.2a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 8.3H12.5A1.5 1.5 0 0 0 14 6.8V2a.5.5 0 0 1 .5-.5"/>
                        </svg>
                        <span className='mx-2'>Regresar</span>
                    </button>
                </Link>
            </div>
            <div className='col-12 pb-2 fs-3 fw-semibold'>
                DETALLE DE CLIENTE / PROVEEDOR
            </div>
            <div className="col-12 col-md-6">
                <div className="p-1">
                    <label className="form-label fw-semibold" htmlFor="tipo-documento">Documento de Identidad</label>
                    <select onChange={e=>HandlerTipoDoc(e.target.value)} value={tipoDoc} id="tipo-documento" className="form-select text-capitalize">
                        {selectTipoDoc}
                    </select>
                </div>
                <div className="p-1">
                    <label className="form-label fw-semibold" htmlFor="nro-documento">N° Documento</label>
                    <div className="input-group mb-3">
                        <input onChange={e=>HandlerNroDoc(e.target.value)} value={nroDoc} maxLength={tipoDoc == '1' ? 8 : 11} type="text" className="form-control" id="nro-documento" autoComplete="off"/>
                    </div>
                </div>
                <div className="p-1">
                    <label className="form-label fw-semibold" htmlFor="nombre-cliente">Nombre Completo</label>
                    <input onChange={e=>HandlerNombre(e.target.value)} value={nombre} maxLength={120} type="text" className="form-control text-uppercase" id="nombre-cliente" autoComplete="off"/>
                </div>
            </div>
            <div className="col-12 col-md-6">
                <div className="py-4">
                    <div className="form-check form-switch fs-5">
                        <input onChange={e=>HandlerEsProveedor(e.target.checked)} checked={esProveedor} className="form-check-input" type="checkbox" role="switch" id="cliente-proveedor"/>
                        <label className="form-check-label fw-semibold" htmlFor="cliente-proveedor">Proveedor</label>
                    </div>
                </div>
                <div className="p-1">
                    <label className="form-label fw-semibold" htmlFor="direccion-cliente">Dirección</label>
                    <input onChange={e=>HandlerDireccion(e.target.value)} value={direccion} maxLength={150} type="text" className="form-control text-uppercase" id="direccion-cliente" autoComplete="off"/>
                </div>
                <div className="row p-3">
                    <div className="col-12 col-md-4 p-1">
                        <div className="form-floating">
                            <select disabled={direccion == ""} onChange={e=>HandlerDpto(e.target.value)} value={dpto} id="dpto-cliente" className="form-select" placeholder="Departamento">
                                <option value="">Seleccionar</option>
                                <ListaDepartamentos/>
                            </select>
                            <label htmlFor="dpto-cliente">Departamento</label>
                        </div>
                    </div>
                    <div className="col-12 col-md-4 p-1">
                        <div className="form-floating">
                            <select disabled={direccion == ""} onChange={e=>HandlerProv(e.target.value)} value={prov} id="prov-cliente" className="form-select" placeholder="Provincia">
                                <option value="">Seleccionar</option>
                                <ListaProvincias departamento={dpto}/>
                            </select>
                            <label htmlFor="prov-cliente">Provincia</label>
                        </div>
                    </div>
                    <div className="col-12 col-md-4 p-1">
                        <div className="form-floating">
                            <select disabled={direccion == ""} onChange={e => HandlerDist(e.target.value)} value={dist} id="dist-cliente" className="form-select" placeholder="Distrito">
                                <option value="">Seleccionar</option>
                                <ListaDistritos provincia={prov} departamento={dpto}/>
                            </select>
                            <label htmlFor="dist-cliente">Distrito</label>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-12 py-3 d-flex justify-content-center align-items-center">
                <button onClick={EditarCliente} disabled={!datosCompletos} className="btn btn-primary">Guardar Cambios</button>
            </div>
        </div>
    </div>
    </>)

    //#endregion
}

// ======================================================================================================
//#region CONSTANTES
// ======================================================================================================
const URL_DATOS_CLIENTE = process.env.REACT_APP_URL_DATOS_CLIENTE;
const URL_CONSULTA_TIPOS_DOCUMENTO = process.env.REACT_APP_URL_TIPOS_DOCUMENTO;
const URL_EDITAR_CLIENTE = process.env.REACT_APP_URL_EDITAR_CLIENTE;
//#endregion